import { Component, OnInit, ViewChild } from '@angular/core';
import { ProjectTableDto } from 'src/app/entity/projectTableDto';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { UserService } from 'src/app/user/user.service';
import { MatDialog } from '@angular/material/dialog';
import { User } from 'src/app/entity/user';
import { AuthService } from 'src/app/auth/api/auth.service';
import { ProjectService } from '../project.service';
import { SnackbarService } from 'src/app/snackbar/service/snackbar.service';
import { Project } from 'src/app/entity/project';
import { ProjectDetailViewComponent } from '../project-detail-view/project-detail-view.component';

@Component({
  selector: 'app-project-table-view',
  templateUrl: './project-table-view.component.html',
  styleUrls: ['./project-table-view.component.scss'],
})
export class ProjectTableViewComponent implements OnInit {
  projects: MatTableDataSource<ProjectTableDto>;
  displayedColumns: string[] = ['name', 'licenceName', 'roomCount', 'buttons'];

  activeUser: User;
  licenceId: number;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(
    private router: Router,
    private authService: AuthService,
    private projectService: ProjectService,
    private userService: UserService,
    private snackbarService: SnackbarService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.projects = new MatTableDataSource();
    this.getProjectsForUser();
  }

  getProjectsForUser() {
    console.log('user id:' + this.authService.getUserId());

    this.userService
      .getUserById(this.authService.getUserId())
      .subscribe((userResult) => {
        if (userResult != null && userResult.licenceId !== undefined) {
          this.licenceId = userResult.licenceId;
          this.projectService.getProjectsByLicence(this.licenceId).subscribe(
            (licenceResult) => {
              this.projects.data = licenceResult;

              if (this.projects !== undefined) {
                this.projects.paginator = this.paginator;
                this.projects.paginator._changePageSize(10);
                this.projects.sort = this.sort;
              }
            },
            (error) => {
              this.snackbarService.open(
                'project.table.snackbar.errorWhileLoading',
                4,
                'failed'
              );
            }
          );
        } else {
          console.log('Kein User gefunden oder User enthält keine licenceId');
        }
      });
  }

  createNewProject() {
    const newProject = new Project();
    newProject.licenceId = this.licenceId.toString();
    const dialogRef = this.dialog.open(ProjectDetailViewComponent, {
      data: newProject,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getProjectsForUser();
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.projects.filter = filterValue.trim().toLowerCase();
  }

  showDetails(id: number) {
    let project: Project;
    console.log('projeckt id: ' + id);
    this.projectService.getProjectById(id).subscribe(
      (projectResult) => {
        project = projectResult;

        const dialogRef = this.dialog.open(ProjectDetailViewComponent, {
          data: project,
        });

        dialogRef.afterClosed().subscribe((result) => {
          this.getProjectsForUser();
        });
      },
      (error) => {
        console.error('Project mit id nicht gefunden.');
      }
    );
  }
}
